export default __webpack_public_path__ + "static/media/Download_Button_Appple.2a6da9de.svg";